// Centralized authentication token storage.
//
// Currently uses localStorage. To migrate to httpOnly cookies in the future,
// only this module needs to change (and the backend must set/read cookies).
// This indirection prevents leaking token storage details across the app.
//
// Recommended hardening for production:
//   * httpOnly + Secure + SameSite=Strict cookies
//   * Short-lived access token, refresh rotation
//   * Subresource integrity for the JS bundle

const ACCESS_KEY = 'alg_access_token';
const REFRESH_KEY = 'alg_refresh_token';

let memoryAccess = null;
let memoryRefresh = null;

function safeGet(key) {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
function safeSet(key, value) {
  try { window.localStorage.setItem(key, value); } catch { /* noop */ }
}
function safeRemove(key) {
  try { window.localStorage.removeItem(key); } catch { /* noop */ }
}

export function getAccessToken() {
  return memoryAccess || safeGet(ACCESS_KEY);
}

export function getRefreshToken() {
  return memoryRefresh || safeGet(REFRESH_KEY);
}

export function setTokens({ accessToken, refreshToken }) {
  if (accessToken !== undefined) {
    memoryAccess = accessToken;
    if (accessToken === null) safeRemove(ACCESS_KEY); else safeSet(ACCESS_KEY, accessToken);
  }
  if (refreshToken !== undefined) {
    memoryRefresh = refreshToken;
    if (refreshToken === null) safeRemove(REFRESH_KEY); else safeSet(REFRESH_KEY, refreshToken);
  }
}

export function clearTokens() {
  memoryAccess = null;
  memoryRefresh = null;
  safeRemove(ACCESS_KEY);
  safeRemove(REFRESH_KEY);
}
